import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import subsection_style from "./style.js";

import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

import LazyVideo from "./lazy-video";

import teaser1 from "./video/track-teaser.mp4"
import teaser2 from "./video/fwd_right-teaser.mp4"
import teaser3 from "./video/seek-teaser.mp4"

import res1 from "./video/composed/bwd-left01.mp4"
import res2 from "./video/composed/fwd-right02.mp4"

import res3 from "./video/complex/seek2.mp4"
import res4 from "./video/complex/seek3.mp4"
import res5 from "./video/complex/explosion.mp4"
import res6 from "./video/complex/explosion2.mp4"
import res7 from "./video/complex/rotate02.mp4"
import res8 from "./video/complex/switch-track2.mp4"
import res9 from "./video/complex/seek4.mp4"
import res10 from "./video/complex/rotate01.mp4"
import res11 from "./video/complex/shake01.mp4"
import res12 from "./video/complex/switch-track1.mp4"
import res13 from "./video/complex/dolly_zoom.mp4"

import rese1 from "./video/simple/simple-1.mp4"
import rese2 from "./video/simple/simple-2.mp4"
import rese3 from "./video/simple/simple-3.mp4"

import resc1 from "./video/composed/fwd-left01.mp4"
import resc2 from "./video/composed/bwd-left02.mp4"
import resc3 from "./video/composed/bwd-right01.mp4"
import resc4 from "./video/composed/fwd-right01.mp4"


const myVideo = () => (
  <div>
    <Header as="h2" textAlign="center" style={subsection_style}>
      Our Results
    </Header>
    <Grid columns={3} stackable>

  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">Simple Camera Motion</h4>
    </Grid.Column>
  </Grid.Row>
  <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={rese1} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pushes forward, focusing</strong> on a roaring campfire.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> The campfire is surrounded by logs and stones, with a forest backdrop. 
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rese2} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> tilts up</strong> from a seashell.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A large conch shell is placed on wet sand near the shoreline, with gentle waves washing nearby.
</p>
    </Grid.Column>
        <Grid.Column textAlign="center">
      <LazyVideo src={rese3} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> trucks right</strong> from a static rowboat.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> There is a wooden rowboat tethered to a dock, with fishing nets and a tackle box inside.
</p>
    </Grid.Column>
  </Grid.Row>


  {/* Row 1: Header for "Composed Camera Motion" */}
  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">Composed Camera Motion</h4>
    </Grid.Column>
  </Grid.Row>

  {/* Row 2: First set of videos (Composed Camera Motion) */}
  <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={res1} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pulls back</strong>, 
  <strong style={{ color: "blue" }}> moving away</strong> from a static painting on an easel. Then the camera
  <strong style={{ color: "blue" }}> trucks left</strong>.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> An unfinished painting on an easel is surrounded by paintbrushes and tubes of paint.
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={res2} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pushes forward</strong>, highlighting a toddler blowing bubbles. Then, the camera 
  <strong style={{ color: "blue" }}> trucks right</strong>.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A toddler giggles as bubbles float away in a sunny backyard, with toys and a garden visible in the background.
</p>
    </Grid.Column>
  <Grid.Column textAlign="center">
      <LazyVideo src={resc1} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pushing forward, focusing</strong> on a hedgehog waddling through a garden. Then, the camera
  <strong style={{ color: "blue" }}> trucks left</strong>.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A tiny hedgehog ambles across a flower bed, its quills glinting in the sunlight as it sniffs around for insects.
</p>
    </Grid.Column>
  </Grid.Row>

<Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={resc2} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pulls back</strong>, 
  <strong style={{ color: "blue" }}> moving away</strong> from a static bouquet of flowers. Then the camera
  <strong style={{ color: "blue" }}> trucks left</strong>.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A vibrant bouquet of flowers stands in a vase on a kitchen counter surrounded by fruits and a small cutting board.
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={resc3} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pulls back</strong>, 
  <strong style={{ color: "blue" }}> moving away</strong> from a train speeding along the tracks. Then, the camera
  <strong style={{ color: "blue" }}> trucks right</strong>.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A sleek train glides along steel tracks, cutting through a misty forest landscape.
</p>
    </Grid.Column>
  <Grid.Column textAlign="center">
      <LazyVideo src={resc4} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pushes forward, focusing</strong> on a static steaming rice bowl. Then the camera
  <strong style={{ color: "blue" }}> trucks right</strong>.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A bowl of steaming white rice is placed on a bamboo mat next to chopsticks and a plate of dumplings.
</p>
    </Grid.Column>
  </Grid.Row>


  {/* Row 3: Header for "Complex Camera Motion" */}
  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">Complex Camera Motion</h4>
    </Grid.Column>
  </Grid.Row>

  {/* Row 4: Second set of videos (Complex Camera Motion) */}
  <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={res3} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pans around, searching</strong> for a static steaming loaf of bread. Upon finding it, the camera
  <strong style={{ color: "blue" }}> locks focus</strong> and
  <strong style={{ color: "blue" }}> pushes in</strong> on the golden crust.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A loaf of bread cools on a wooden cutting board, with a knife and a small dish of butter.
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={res9} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pans around, searching</strong> for a static hot air balloon in the sky. Upon finding it, the camera
  <strong style={{ color: "blue" }}> locks focus</strong> and
  <strong style={{ color: "blue" }}> pushes in</strong> on the colorful panels.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A hot air balloon floats above rolling hills, with the setting sun painting the sky in shades of orange and pink.
</p>
    </Grid.Column>
  <Grid.Column textAlign="center">
      <LazyVideo src={res12} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pulls out</strong> from a brass compass. Then, the camera
  <strong style={{ color: "blue" }}> switches focus</strong> to a leather satchel.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> The compass sits open, its needle steady, while the satchel beside it is worn with age, its straps slightly frayed.
</p>
    </Grid.Column>
  </Grid.Row>

    <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={res5} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pushes forward</strong> with 
  <strong style={{ color: "blue" }}> intermittent explosive tremors, focusing</strong> on a worn-out teddy bear lying on scorched ground.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A car explodes in a fiery blast, sending debris and dust into the air.
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={res6} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pushes forward</strong> with 
  <strong style={{ color: "blue" }}> intermittent explosive tremors, focusing</strong> on a typewriter covered in ash. 
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> Nearby a typewriter, a wall of flame roars as a gas line explodes, shaking the entire area. 
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={res11} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> shakily pushes forward, focusing</strong> on a static pair of hiking boots.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> There are a pair of muddy hiking boots resting near a campfire, with a backpack leaning against a log.
</p>
    </Grid.Column>
  </Grid.Row>

    <Grid.Row>
    <Grid.Column textAlign="center">
<LazyVideo src={res13} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera executes a
  <strong style={{ color: "blue" }}>  dolly zoom.</strong>
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A steaming coffee cup rests on a wooden table beside a stack of books and a pair of glasses.
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={res10} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> orbits</strong> the static snow globe. 
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A snow globe featuring a tiny winter village sits on a mantelpiece, surrounded by festive decorations. 
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={res8} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera first
  <strong style={{ color: "blue" }}> tracks</strong> a flying sparrow. Then, the camera
  <strong style={{ color: "blue" }}> switches focus</strong> to a black-feathered crow.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> The sparrow darts swiftly through the air, settling on a branch dotted with pink blossoms.
</p>
    </Grid.Column>
  </Grid.Row>
</Grid>

  </div>
);

export default myVideo;
